import styled from "styled-components";

export const InternalOrExternalCard = styled.div`
  flex: 1;
  background: white;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 16px;
`

export const CardTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #303030;
  margin: 0 0 4px 0;
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`

export const CheckboxContainer = styled.div`
  width: 18px;
  height: 18px;
  border: 1px solid ${(props:{checked: boolean}) => props.checked ? '#0090D3' : '#ebebeb'};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${(props:{checked: boolean}) => props.checked ? '#0090D3' : 'white'};
`

export const Label = styled.label`
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #303030;
  cursor: pointer;
`

export const InputContainer = styled.div`
  flex: 1;
  background: #ebebeb;
  border-radius: 20px;
  padding: 10px 16px;
`

export const Input = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #696969;
  outline: none;
  
  &::placeholder {
    color: #696969;
  }
`